<template>
  <div class="faq" id="faq">
    <FAQItem :icon="profit" question="What is 485x and why should I care?"
      answer="485x is a long-term tax incentive program that rewards property owners for including affordable housing. By reducing property taxes, 485x increases the NOI and property value by 25-30%." />
    <FAQItem :icon="layers" question="How does UAP* boost my project?"
      answer="UAP adds bonus floor area in exchange for affordable units, increasing density without added land acquisition costs."
      note="Universal Affordability Preference under City of Yes" />
    <FAQItem :icon="puzzle" question="Can I use both 485x and UAP together?"
      answer="Yes! Most affordable units can be utilized to meet the requirements of both 485x and UAP. By combining these programs, developers dramatically lower property taxes while expanding buildable floor area." />
    <FAQItem :icon="target" question="What projects are a good fit for regtime builder?"
      answer="Our tool is designed for development sites located in high-density zoning districts, intended for rental housing, with as-of-right buildable floor area of 100,000 square feet or less." />
  </div>
</template>

<script>
import FAQItem from '@/components/FAQItem.vue';
import Puzzle from '@/assets/puzzle.svg';
import Layers from '@/assets/layers.svg';
import Target from '@/assets/target.svg';
import Profit from '@/assets/profit.svg';

export default {
  name: 'FAQ',
  components: {
    FAQItem,
  },
  data () {
    return {
      puzzle: Puzzle,
      layers: Layers,
      target: Target,
      profit: Profit,
    };
  },
};
</script>

<style scoped>
.faq {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  align-self: stretch;
  background: #F9FAFF;
  padding: 80px 60px 120px 60px;
  justify-items: center;
}

@media (max-width: 1000px) {
  .faq {
    grid-template-columns: 1fr;
  }
}
</style>
